<template>
  <div class="desktop-only">
    <footer>
      <div class="footer-copyright text-white">
        <span class="text-white">© mangoSTEEMS .Inc |</span>

        <a
          class="underline pointer iubenda-nostyle no-brand iubenda-embed"
          href="https://www.iubenda.com/privacy-policy/32601846"
        >
          Privacy Policy</a
        >
        |
        <a
          class="underline pointer iubenda-nostyle no-brand iubenda-embed"
          href="https://www.iubenda.com/privacy-policy/32601846/cookie-policy"
          >Cookie Policy</a
        >
        |
        <a
          class="underline pointer iubenda-nostyle no-brand iubenda-embed"
          href="https://www.iubenda.com/terms-and-conditions/32601846"
          >Terms and Conditions</a
        >
        |
        <a
          class="underline pointer iubenda-nostyle no-brand"
          href="https://www.mangosteems.com/"
          >About Us</a
        >
        |
        <a
          class="underline pointer iubenda-nostyle no-brand"
          @click="gotoDisclaimer"
          >Disclaimer</a
        >
      </div>
    </footer>
  </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const gotoDisclaimer = () => {
  router.push("/disclaimer");
};
(function (w, d) {
  var loader = function () {
    var s = d.createElement("script"),
      tag = d.getElementsByTagName("script")[0];
    s.src = "https://cdn.iubenda.com/iubenda.js";
    tag.parentNode.insertBefore(s, tag);
  };
  console.log(w.addEventListener);
  if (w.addEventListener) {
    w.addEventListener("load", loader, false);
  } else if (w.attachEvent) {
    w.attachEvent("onload", loader);
  } else {
    w.onload = loader;
  }
})(window, document);
onMounted(() => {
  console.log("window innerwidth = ", window.innerWidth);
});
</script>
<style lang="scss" scoped>
.underline:hover {
  border-bottom: 1px #ffffff solid;
  padding-bottom: 2px;
}
footer {
  position: fixed;
}

/* 電腦上顯示 */
/* 默认情况下显示元素 */
.desktop-only {
  display: block;
}

/* 平板和手机上隐藏元素 */
@media only screen and (max-width: 767px) {
  .desktop-only {
    display: none;
  }
}
</style>
